const _padding = "1rem"
const config = { "padding": _padding,  }
export { config as default, _padding }